import React from "react";
import Card from "./Card";
import QRCode from "react-qr-code";
import { FiCopy, FiShare2 } from "react-icons/fi";
import "./ReferLinkCard.css";

const ReferralLinkCard = ({ link, onCopy, onShare }) => {
  return (
    <Card>
        <div className="linkhead1">
            <h4>Your Referral Link</h4>
            <hr />
        </div>
      
      <div className="referral-link-box1">
        <div className="box1">
            <QRCode value={link} size={80} />
        </div>
        

        <div className="link-input-box1">
          <input value={link} readOnly  maxLength={255} />
          <button onClick={onCopy}>
            <FiCopy />
          </button>
        </div>

        <button className="share-btn1" onClick={onShare}>
          <FiShare2 /> Share
        </button>
      </div>
    </Card>
  );
};

export default ReferralLinkCard;
